import { BilliardsRackIcon } from './BilliardsRackIcon';

/**
 * author: Michael Richins
 * id 2ED0EE4C-D928-41C6-8D5D-3AA3A2DF7AF6
 * name billiards-rack
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/billiards-rack.svg
 * tags
 * - Sport 
 */
export const SnookerRackIcon = BilliardsRackIcon;
export default SnookerRackIcon